import { cn } from "@/lib/utils";
import { Button } from "../button/button";
import { Logo } from "../logo/logo";
import simensLogo from "./siemens-logo.png";
import { Spinner } from "../spinner/spinner";
import { useTranslation } from "react-i18next";
import { PropsWithChildren } from "react";

export interface LoginOverlayProps extends PropsWithChildren {
  opacity?: boolean;
  loading?: boolean;
  onLoginClick: () => void;
}

export function LoginOverlay(props: LoginOverlayProps) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        { "opacity-90 fade-in-0 animate-in": props.opacity },
        "flex gap-12 flex-col absolute top-0 left-0 bottom-0 right-0 bg-header justify-center items-center z-50"
      )}
    >
      <Logo width="100" />
      <Button
        disabled={props.loading}
        variant={"secondary"}
        className="px-3 py-2 flex gap-2"
        onClick={props.onLoginClick}
      >
        {!props.loading && (
          <img src={simensLogo} className="h-full rounded-sm" />
        )}
        {props.loading && <Spinner className="mr-0 w-6" />}
        {t("login.simensOAuth")}
      </Button>
      {props.children}
    </div>
  );
}
